import * as Sentry from '@sentry/react'
import { reactRouterV6BrowserTracingIntegration, replayIntegration } from '@sentry/react'
import { useEffect } from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'

// Setup Sentry Error Reporting
export const initSentry = () => {
  // Disable Sentry in development
  if (process.env.NODE_ENV === 'development') return

  Sentry.init({
    dsn: 'https://fab6fbefb85e42b98c6de3bba017d783@o4504599098425345.ingest.sentry.io/4504605296820224',
    environment: window.location.host,
    // Sample only a small percentage of user traces
    tracesSampleRate: 0.1,
    // Sample 1% of regular sessions, but 100% of sessions where an error occurs
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
      reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
        // Propagate tracing ids to our APIs
        tracePropagationTargets: ['localhost', 'api.fruitfuloffice.com'],
      }),
    ],
  })
}
